import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHistory } from 'react-router-dom';
import { createHierarchy } from 'services/api/requests/commercial';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const useCreateHierarchy = (body, form?, setForm?) => {
	const queryClient = useQueryClient();
	const toast = useToast();
	const history = useHistory();

	return useMutation(() => createHierarchy(body), {
		onSuccess: success => {
			queryClient.invalidateQueries(['hierarquiaComercial-list']);
			history.goBack();
			toast({
				title: 'Criada com sucesso!',
				description: 'A hierarquia foi criada com sucesso!',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
			if (form && setForm) {
				setForm({
					...form,
					nomeMercado: success.id,
				});
			}
		},
		onError: (error: any, variables, context) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao criar Hierarquia Comercial!',
				'Verifique se os campos estão preenchidos corretamente. Os campos Canal de Venda, Zona de Venda e Membro são obrigatórios.'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
